import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetPastCourses = () => {
    const {
        data: pastCourses,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["pastCourses"],
        queryFn: () =>
            axiosManager.get$("/courses/past").then((res) => res.data),
    });

    return { pastCourses, error, isLoading };
};

export default useGetPastCourses;
